function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M12 0.786133C18.1932 0.786347 23.2146 5.80685 23.2148 12C23.2146 18.1932 18.1932 23.2146 12 23.2148C5.80686 23.2146 0.78636 18.1932 0.786133 12C0.786359 5.80685 5.80685 0.786359 12 0.786133ZM12 2.78613C6.91142 2.78636 2.78636 6.91142 2.78613 12C2.78636 17.0886 6.91142 21.2146 12 21.2148C17.0887 21.2146 21.2146 17.0887 21.2148 12C21.2146 6.91141 17.0887 2.78635 12 2.78613ZM12 14.9287L12.1426 14.9355C12.8447 15.0069 13.3924 15.6003 13.3926 16.3213C13.3925 17.0543 12.8263 17.653 12.1074 17.708C12.1054 17.7082 12.1036 17.7098 12.1016 17.71L12 17.7148L11.8975 17.71C11.8948 17.7097 11.8923 17.7083 11.8896 17.708C11.1721 17.6516 10.6075 17.0533 10.6074 16.3213C10.6076 15.587 11.1757 14.9866 11.8965 14.9336C11.9305 14.9301 11.9651 14.9287 12 14.9287ZM12 6.28613C12.5523 6.28613 13 6.73385 13 7.28613V12.3936C12.9996 12.9455 12.5521 13.3936 12 13.3936C11.4479 13.3936 11.0004 12.9455 11 12.3936V7.28613C11 6.73385 11.4477 6.28613 12 6.28613Z"
});

var SvgError = function SvgError(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgError, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/error.be726d96.svg";
export { ForwardRef as ReactComponent };